<template>
    <div :key="uuid" class="col-4 toc_panel toc_instructor ace_sec" aria-label="TOC section">
        <b-list-group
          <div class="list-group-item">
              <div class="toc_row table-content-header">
                  <span class="icon-ic_ToC"></span>
                  <span class="header-text ace_sec_hd toc_hd_txt">{{course.title}} - {{LABELS.TOC}}</span>
                  <span class="progress_block">
  	                <span class="state" :class="statusClass(course.uuid)">
  	                	<span class="progress_val ace_sec_txt" :id="'prog_' + course.uuid"></span>
  	                </span>
                  </span>
              </div>
          </div>
			<div class="content-scroll-column">
				<b-list-group-item class="topic-list-item" v-for="topic in topics" :key="topic.uuid">

					<div class="toc_row row_1" :id="'nodeRow_' + topic.uuid">
						<button class="icon ic-expand_r" :id="'ic_' + topic.uuid" v-b-toggle="'tc_' + topic.uuid" v-on:click="switchClass(topic.uuid)"></button>
						<b-link :to="{ name: 'entityDetailInstructor', params: { uuid: course.uuid, entityType: topic.objectType, entityUuid: topic.uuid } }">
							<span class="lnk_txt ace_sec_txt" :aria-label="topic.title"  v-on:click="expandCollapseTreeNode(topic.uuid)">{{topic.title}}</span>
						</b-link>
						<span class="progress_block">
							<span class="state" :class="statusClass(topic.uuid)">
								<span class="progress_val ace_sec_txt" :id="'prog_' + topic.uuid"></span>
							</span>
						</span>
					</div>

					<!--sub topic -->
					<b-collapse :id="'tc_' + topic.uuid">
						<b-list-group v-if="topic.subtopics">

							<b-list-group-item class="topic-list-item" v-for="subtopic in topic.subtopics" :key="subtopic.uuid">
                <div class="toc_row row_3 top-level-assets" :class="{active_row:selectedRow === 'r_'+subtopic.uuid}" :id="'tc_' + subtopic.uuid" v-if="subtopic.objectType === 'LearningContent'">
                  <b-link :to="{ name: 'entityDetailInstructor', params: { uuid: course.uuid, entityType: subtopic.objectType, entityUuid: subtopic.uuid } }" @click="setSelectedRow(subtopic.uuid)">
                    <span class="ic_container"><span v-if="subtopic.fileType === 'assessment'" class="icon icon-assessment" @click="setSelectedRow(subtopic.uuid)"></span>
                    <span v-if="subtopic.fileType === 'video'" class="icon icon-video" @click="setSelectedRow(subtopic.uuid)"></span>
                    <span v-if="subtopic.fileType === 'pdf'" class="icon icon-file-pdf" @click="setSelectedRow(subtopic.uuid)"></span>
                    <span v-if="subtopic.fileType === 'csv'" class="icon icon-csvFile"></span>
                    <span v-if="subtopic.fileType === 'txt'" class="icon icon-file-text"></span>
                    <span v-if="subtopic.fileType === 'mp4' || subtopic.fileType === 'mp3'" class="icon icon-video"></span>
                    <span v-if="subtopic.fileType === 'zip'" class="icon icon-file-zip"></span>
                    <span v-if="subtopic.fileType === 'doc' || subtopic.fileType === 'docx'" class="icon icon-file-word" @click="setSelectedRow(subtopic.uuid)"></span>
                    <span v-if="subtopic.fileType === 'ppt' || subtopic.fileType === 'pptx'" class="icon icon-pagePPT" @click="setSelectedRow(subtopic.uuid)"></span>
                    <span v-if="subtopic.fileType === 'xlsx'" class="icon icon-file-excel" @click="setSelectedRow(subtopic.uuid)"></span>
                    <span v-if="subtopic.fileType === 'html'" class="icon icon-pageURL" @click="setSelectedRow(subtopic.uuid)"></span>
                    <span v-if="subtopic.fileType === 'other'" class="icon icon-pageURL" @click="setSelectedRow(subtopic.uuid)"></span>
                    <span v-if="subtopic.fileType === 'scorm'" class="icon icon-scorm" @click="setSelectedRow(subtopic.uuid)"></span>
                    <span v-if="subtopic.fileType === 'externalurl'" class="icon icon-pageURL" @click="setSelectedRow(subtopic.uuid)"></span>
                    <span v-if="subtopic.fileType === 'jpg' || subtopic.fileType === 'jpeg' || subtopic.fileType === 'png' || subtopic.fileType === 'gif'" class="icon icon-image" @click="setSelectedRow(subtopic.uuid)"></span>
                    </span><span class="lnk_txt ace_sec_txt" :aria-label="subtopic.title" @click="setSelectedRow(subtopic.uuid)">{{subtopic.title}}</span>
                  </b-link>
                  <span class="progress_block">
                    <span class="state" :class="statusClass(subtopic.uuid)" v-if="subtopic.fileType === 'assessment' || subtopic.type === 'RICH_HTML' || subtopic.fileType === 'scorm'">
                      <span class="progress_val ace_sec_txt" :id="'prog_' + subtopic.uuid"></span>
                    </span>
                    <span class="state ace_sec_txt" :class="resourseStatusClass(subtopic.uuid)" v-if="subtopic.fileType !== 'assessment'">
                    </span>
                  </span>
                </div>
                <div class="toc_row row_2" :id="'nodeRow_' + subtopic.uuid" v-else>
									<button class="icon ic-expand_r" :id="'ic_' + subtopic.uuid" v-b-toggle="'tc_' + subtopic.uuid" v-on:click="switchClass(subtopic.uuid)"></button>
									<b-link :to="{ name: 'entityDetailInstructor', params: { uuid: course.uuid, entityType: subtopic.objectType, entityUuid: subtopic.uuid } }">
										<span class="lnk_txt" :aria-label="subtopic.title" v-on:click="expandCollapseTreeNode(subtopic.uuid)">{{subtopic.title}}</span>
									</b-link>
                  <button class="btn_ic ic-lock" :title="$tf('openOn') + ' ' + subtopic.unlockReliantOnTitle[0]" v-if="subtopic.unlockReliantOn.length>0" v-on:click="openUnlockCompetencyModal(subtopic)" v-b-tooltip.hover></button>
                  <span class="progress_block">
										<span class="state" :class="statusClass(subtopic.uuid)">
											<span class="progress_val ace_sec_txt" :id="'prog_' + subtopic.uuid"></span>
										</span>
									</span>
                </div>

								<!-- sub sub topic -->
								<b-collapse :id="'tc_' + subtopic.uuid">
									<b-list-group v-if="subtopic.subtopics">
										<b-list-group-item class="topic-list-item" v-for="subsubtopic in subtopic.subtopics" :key="subsubtopic.uuid">
											<div class="toc_row row_3" :class="{active_row:selectedRow === 'r_'+subsubtopic.uuid}" :id="'tc_' + subsubtopic.uuid">
												<b-link :to="{ name: 'entityDetailInstructor', params: { uuid: course.uuid, entityType: subsubtopic.objectType, entityUuid: subsubtopic.uuid } }" @click="setSelectedRow(subsubtopic.uuid)">
													<span class="ic_container"><span v-if="subsubtopic.fileType === 'assessment'" class="icon icon-assessment" @click="setSelectedRow(subsubtopic.uuid)"></span>
													<span v-if="subsubtopic.fileType === 'video'" class="icon icon-video" @click="setSelectedRow(subsubtopic.uuid)"></span>
													<span v-if="subsubtopic.fileType === 'pdf'" class="icon icon-file-pdf" @click="setSelectedRow(subsubtopic.uuid)"></span>
													<span v-if="subsubtopic.fileType === 'csv'" class="icon icon-csvFile"></span>
													<span v-if="subsubtopic.fileType === 'txt'" class="icon icon-file-text"></span>
													<span v-if="subsubtopic.fileType === 'mp4' || subsubtopic.fileType === 'mp3'" class="icon icon-video"></span>
													<span v-if="subsubtopic.fileType === 'zip'" class="icon icon-file-zip"></span>
													<span v-if="subsubtopic.fileType === 'doc' || subsubtopic.fileType === 'docx'" class="icon icon-file-word" @click="setSelectedRow(subsubtopic.uuid)"></span>
													<span v-if="subsubtopic.fileType === 'ppt' || subsubtopic.fileType === 'pptx'" class="icon icon-pagePPT" @click="setSelectedRow(subsubtopic.uuid)"></span>
													<span v-if="subsubtopic.fileType === 'xlsx'" class="icon icon-file-excel" @click="setSelectedRow(subsubtopic.uuid)"></span>
													<span v-if="subsubtopic.fileType === 'html'" class="icon icon-pageURL" @click="setSelectedRow(subsubtopic.uuid)"></span>
													<span v-if="subsubtopic.fileType === 'other'" class="icon icon-pageURL" @click="setSelectedRow(subsubtopic.uuid)"></span>
                          <span v-if="subsubtopic.fileType === 'scorm'" class="icon icon-scorm" @click="setSelectedRow(subsubtopic.uuid)"></span>
													<span v-if="subsubtopic.fileType === 'externalurl'" class="icon icon-pageURL" @click="setSelectedRow(subsubtopic.uuid)"></span>
													<span v-if="subsubtopic.fileType === 'jpg' || subsubtopic.fileType === 'jpeg' || subsubtopic.fileType === 'png' || subsubtopic.fileType === 'gif'" class="icon icon-image" @click="setSelectedRow(subsubtopic.uuid)"></span>
													</span><span class="lnk_txt ace_sec_txt" :aria-label="subsubtopic.title" @click="setSelectedRow(subsubtopic.uuid)">{{subsubtopic.title}}</span>
												</b-link>
												<span class="progress_block">
													<span class="state" :class="statusClass(subsubtopic.uuid)" v-if="subsubtopic.fileType === 'assessment' || subsubtopic.fileType === 'scorm'">
														<span class="progress_val ace_sec_txt" :id="'prog_' + subsubtopic.uuid"></span>
													</span>
													<span class="state ace_sec_txt" :class="resourseStatusClass(subsubtopic.uuid)" v-if="subsubtopic.fileType !== 'assessment' && subsubtopic.fileType !== 'scorm'">
													</span>
												</span>
											</div>
										</b-list-group-item>
									</b-list-group>
								</b-collapse>
								<!-- sub sub topic ends-->

							</b-list-group-item>

						</b-list-group>
					</b-collapse>
					<!--sub topic ends -->

				</b-list-group-item>
			</div>
        </b-list-group>
    <div>
      <b-modal class="modal__v22_2" ref="unlockCompetencyModal" title="Unlock Micro Competency" :header-bg-variant="'course-content-edit-modal'" size="lg" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
        <div slot="modal-header" class="row header-section w-100">
          <div class="col-8 hd">
            <div class="ic_container">
            </div>
            <div class="hd_txt">
              <span>Unlock this Micro Competency</span>
            </div>
          </div>
          <div class="col-4 btn_container pr-0">
            <button class="btn_close" aria-label="close" @click="closeUnlockCompetencyModal()">
               <span class="ic-close"></span>
            </button>
          </div>
        </div>

        <div class="row">
          <div class="col-11 popup_content">
            <div class="row fld_row mb-4">
              <div class="col-12 msg" v-if="mcToBeUnlocked.unlockReliantOnTitle">
              <template v-if="mcToBeUnlocked.unlockReliantOnType==1">
                This Micro Competency will open when  "{{mcToBeUnlocked.unlockReliantOnTitle[0]}}".
              </template>
              <template v-if="mcToBeUnlocked.unlockReliantOnType==2">
                This Micro Competency will open on "{{mcToBeUnlocked.unlockReliantOnTitle[0]}}".
              </template>
              <template v-if="mcToBeUnlocked.unlockReliantOnType==3">
                This Micro Competency unlock reliant on completion the Diagnostic Test! "{{mcToBeUnlocked.unlockReliantOnTitle[0]}}" <br/>
              </template>
              <template v-if="mcToBeUnlocked.unlockReliantOnType==4">
                This Micro Competency unlock reliant on completion of previous Competency "{{mcToBeUnlocked.unlockReliantOnTitle[0]}}"
              </template>
              <template v-if="mcToBeUnlocked.unlockReliantOnType==5">
                This Micro Competency unlock reliant on completion of previous Micro Competency "{{mcToBeUnlocked.unlockReliantOnTitle[0]}}"
              </template>

              </div>
            </div>
            <div class="row fld_row mb-4">
                <div class="col-12 fld_label">
                  <input class="mr-2" type="radio" name="selectionType" id="all" value="ALL" v-model="selectionType" @change="resetList"> All users
                </div>
                <div class="col-12 fld_label">
                <input class="mr-2" type="radio" name="selectionType" id="all" value="SOME" v-model="selectionType" @change="resetList">
                  Specific user(s)
                    <autocomplete
                      ref="`autocomplete_user`"
                      :source="enrolledUserList"
                      placeholder="start typing and/or click"
                      aria-label="start typing and/or click"
                      input-class="form-control"
                      :results-display="getDynamicSelectFormattedDisplay"
                      @selected="dynamicSelectAfterSelected($event, question, i)">
                    </autocomplete>

                </div>
            </div>

            <div class="row fld_row mb-4">
                <div class="col-12 fld_label">
                  Unlock List
                </div>
            </div>

            <div class="row fld_row mb-4" v-for="unlockForUser in unlockForUserList" :key="unlockForUser.uuid">
                <div class="col-12 fld_label">
                  This Micro Competency is unlocked for
                  <b> {{unlockForUser.title}} </b>
                </div>
            </div>
          </div>
        </div>

        <div slot="modal-footer" class="w-100">
          <b-button @click="unlock()" class="btn button-primary float-right mr-2"> ok </b-button>
          <b-button @click="closeUnlockCompetencyModal()" class="btn button-primary float-right mr-2"> cancel </b-button>
        </div>
      </b-modal>
    </div>

    </div>
</template>

<script>
/* eslint no-labels: ["error", { "allowLoop": true }] */
import { mapState, mapActions } from 'vuex'
import Autocomplete from 'vuejs-auto-complete'

export default {
  name: 'tocinstructor',
  props: ['uuid', 'entityType', 'entityUuid', 'topicUuid', 'subTopicUuid'],
  components: {
  Autocomplete
  },
  data: () => {
    return {
      selectedRow: undefined,
      status_css: {
        10: 'noGrade',
        0: 'gradeE',
        1: 'gradeD',
        2: 'gradeC',
        3: 'gradeB',
        4: 'gradeA'
      },
      resourse_status: {10: 'noGrade', 4: 'gradeA'},
      statusClasses: {},
      fullEnrolledUserList: [],
      alreadyUnlockedUsers: [],
      enrolledUserList: [],
      unlockForUserList: [],
      mcToBeUnlocked: {},
      selectionType: 'SOME'
    }
  },

  created () {
    this.$nextTick(() => {
      setTimeout(() => {
        if (!this.subTopicUuid) {
          if (this.fullClassSummary.length === 0) {
            this.loadFullClassSummary({courseId: this.uuid, loadDataFromServer: true})
          }
          this.expandAfterRefresh()
        }
      }, 1500)
    })
  },

  updated () {
    this.$nextTick(() => {
      this.loadStatusClasses()
      setTimeout(() => {
        this.$forceUpdate()
      }, 250)
    })
  },

  mounted () {
    this.loadCourseTopicsInfo()
  },

  methods: {
    ...mapActions([
      'loadCourseTopics',
      'loadFullClassSummary',
      'loadEnrolledStudentUsers',
      'unlockMicroCompetency',
      'getMicroCompetencyUnlockFor'
    ]),

    expandAfterRefresh () {
      let entityUuid = this.$route.params.entityUuid
      let elemId = '#tc_' + entityUuid
      let childElem = $(elemId).closest('.list-group').parent().get(0)
      let childSibling = $(childElem).prev().get(0)
      if (childSibling) {
        let childNodeId = '#ic_' + $(childSibling).attr('id').split('_')[1]
        let parentElem = $(childSibling).closest('.list-group').parent().get(0)
        let parentSibling = $(parentElem).prev().get(0)
        if (parentSibling) {
          let parentNodeId = '#ic_' + $(parentSibling).attr('id').split('_')[1]
          if ($(parentNodeId).hasClass('collapsed')) {
            $(parentNodeId).click()
            $(childNodeId).click()
            $(elemId).children('a').get(0).click()
          }
        }
      }
    },
    closeUnlockCompetencyModal(){
      this.mcToBeUnlocked = {}
      this.$refs.unlockCompetencyModal.hide()
    },
    async openUnlockCompetencyModal(mcToUnlock){
      this.enrolledUserList = []
      this.unlockForUserList = []
      this.mcToBeUnlocked = mcToUnlock
      this.alreadyUnlockedUsers = await this.getMicroCompetencyUnlockFor(mcToUnlock.uuid)
      this.loadEnrolledStudentUsers(this.uuid).then(res => {
          this.fullEnrolledUserList = []
          this.enrolledUserList = []
          $.each(res.content, (i, user) => {
            var result = {
              uuid: user.uuid,
              title: user.firstName + ' ' + user.lastName
            }
            this.fullEnrolledUserList.push(result)
            let alreadyUnlocked = false
            $.each(this.alreadyUnlockedUsers, (j, aAser) => {
                if(aAser.userId===user.uuid){
                    alreadyUnlocked = true
                }
            })
            if(!alreadyUnlocked){
                this.enrolledUserList.push(result)
            }else{
                this.unlockForUserList.push(result)
            }
          })
          this.$refs.unlockCompetencyModal.show()
        })
    },
    unlock() {
      let userIds = []

      for(var i=0;i<this.unlockForUserList.length;i++){
        userIds[i] = this.unlockForUserList[i].uuid
      }
      this.unlockMicroCompetency({mcId:this.mcToBeUnlocked.uuid, selectionType:this.selectionType, userIds:userIds}).then(res => {
          this.$notify({
            group: 'notify',
            type: 'success',
            title: '',
            text: 'Micro Competency successfully unlocked for selected users.'
          })
          this.$refs.unlockCompetencyModal.hide()
      })

    },
    async loadCourseTopicsInfo () {
      if (this.uuid) {
        await this.loadCourseTopics({uuid: this.uuid, loadDataFromServer: true})
        await this.loadFullClassSummary({courseId: this.uuid, loadDataFromServer: true})
      }
    },
    resetList (){
        this.enrolledUserList = []
        this.unlockForUserList = []
        if(this.selectionType == "SOME"){
          $.each(this.fullEnrolledUserList, (i, user) => {
            let alreadyUnlocked = false
            $.each(this.alreadyUnlockedUsers, (j, aAser) => {
                if(aAser.userId===user.uuid){
                  alreadyUnlocked = true
                }
            })
            if(!alreadyUnlocked){
                this.enrolledUserList.push(user)
            }else{
                this.unlockForUserList.push(user)
            }
          })
        }else{
          $.each(this.fullEnrolledUserList, (i, user) => {
              this.unlockForUserList.push(user)
            })
        }
    },
    getDynamicSelectFormattedDisplay (item) {
        return item.title || item
    },
    dynamicSelectAfterSelected (item, question, i) {
        this.enrolledUserList = this.enrolledUserList.filter(val => val.uuid !== item.selectedObject.uuid);
        this.unlockForUserList.push(item.selectedObject)
    },
    loadStatusClasses () {
      var status = 10
      var performance = 0
      if (this.fullClassSummary && this.fullClassSummary.length > 0) {
        for (var i = 0; i < this.fullClassSummary.length; i++) {
          var competency = this.fullClassSummary[i]
          if ((competency.competencyType === 'RESOURCE') || ((competency.competencyType === 'SCORM') && !competency.classPerformance.performanceAvg)) {
            if (competency.resourceAvgTimeTaken && competency.resourceAvgTimeTaken > 0) {
              status = 4
            } else {
              status = 10
            }
            this.statusClasses[competency.entityId] = this.resourse_status[status]
          } else {
            performance = competency.classPerformance
            if (performance.performanceAvg !== null) {
              $('#prog_' + competency.entityId).html(performance.performanceAvg.toFixed(2) + '%')
              if (performance.performanceAvg >= 90) {
                status = 4
              } else if (performance.performanceAvg >= 80 && performance.performanceAvg < 90) {
                status = 3
              } else if (performance.performanceAvg >= 65 && performance.performanceAvg < 80) {
                status = 2
              } else if (performance.performanceAvg >= 40 && performance.performanceAvg < 65) {
                status = 1
              } else if (performance.performanceAvg < 40) {
                status = 0
              }
            } else {
              status = 10
            }
            this.statusClasses[competency.entityId] = this.status_css[status]
          }
        }
      }
    },

    switchClass (rowId) {
      var elem = $('#ic_' + rowId)
      if (elem.hasClass('ic-expand_r')) {
        elem.removeClass('ic-expand_r')
        elem.addClass('ic-collapse_r')
      } else {
        elem.removeClass('ic-collapse_r')
        elem.addClass('ic-expand_r')
      }
    },

    statusClass (entityId) {
      if (entityId in this.statusClasses) {
        return this.statusClasses[entityId]
      } else {
        return 'noGrade'
      }
    },

    resourseStatusClass (entityId) {
      if (entityId in this.statusClasses) {
        return this.statusClasses[entityId]
      } else {
        return 'noGrade'
      }
    },

    setSelectedRow (uuid) {
      const rowId = 'r_' + uuid
      if ($('.row_3').hasClass('active_row')) {
        if (this.selectedRow !== rowId) {
          $('.row_3').removeClass('active_row')
        }
      }
      this.selectedRow = rowId
    },

    expandCollapseTreeNode (entityId) {
      $('#ic_' + entityId).trigger('click')
    }

  },

  computed: {
    ...mapState({
      'course': state => state.course.course,
      'topics': state => state.course.topics,
      'fullClassSummary': state => state.course.fullClassSummary
    })
  },

  watch: {
    topics () {
      if (!this.entityUuid) {
        topicLoop: for (var i = 0; i < this.topics.length; i++) {
          const topic = this.topics[i]
          if (topic.subtopics && topic.subtopics.length > 0) {
            subTopicLoop: for (var j = 0; j < topic.subtopics.length; j++) {
              const subtopic = topic.subtopics[j]
              if (subtopic.objectType === 'LearningContent') {
                this.$router.push({name: 'entityDetailInstructor', params: {uuid: this.course.uuid, entityType: subtopic.objectType, entityUuid: subtopic.uuid, topicUuid: topic.uuid, subTopicUuid: subtopic.uuid}})
                break topicLoop
              }
              if (subtopic.subtopics && subtopic.subtopics.length > 0) {
                subSubTopicLoop: for (var k = 0; k < subtopic.subtopics.length; k++) {
                  const subsubtopic = subtopic.subtopics[k]
                  if (subsubtopic && subsubtopic.uuid) {
                    this.$router.push({name: 'entityDetailInstructor', params: {uuid: this.course.uuid, entityType: subsubtopic.objectType, entityUuid: subsubtopic.uuid, topicUuid: topic.uuid, subTopicUuid: subtopic.uuid}})
                    break topicLoop
                  }
                }
              } else { // subtopic.subtopics.length ===> 0

              }
            }
          } else { // topic.subtopics ===> 0

          }
        }
      } else {
        if ($('.toc_row').hasClass('active_row')) {
          if (this.entityType === 'LearningContent') {
            $('.toc_row').removeClass('active_row')
          }
        }
        if (!$('#tc_' + this.entityUuid).hasClass('active_row')) {
          $('#tc_' + this.entityUuid).addClass('active_row')
          if (this.subTopicUuid) {
            if (!this.topicUuid) {
              topicLoop: for (var x = 0; x < this.topics.length; x++) {
                const topic = this.topics[x]
                if (topic.subtopics && topic.subtopics.length > 0) {
                  subTopicLoop: for (var y = 0; y < topic.subtopics.length; y++) {
                    const subtopic = topic.subtopics[y]
                    if (subtopic && subtopic.uuid === this.subTopicUuid) {
                      this.topicUuid = topic.uuid
                      break topicLoop
                    }
                  }
                } else {
                  // topic.subtopics === 0
                }
              }
            }
          } else {
            topicLoop: for (var a = 0; a < this.topics.length; a++) {
              const topic = this.topics[a]
              if (topic && topic.subtopics && topic.subtopics.length > 0) {
                subTopicLoop: for (var b = 0; b < topic.subtopics.length; b++) {
                  const subtopic = topic.subtopics[b]
                  if (subtopic.subtopics && subtopic.subtopics.length > 0) {
                    subSubTopicLoop: for (var c = 0; c < subtopic.subtopics.length; c++) {
                      const subsubtopic = subtopic.subtopics[c]
                      if (subsubtopic && subsubtopic.uuid === this.entityUuid) {
                        this.topicUuid = topic.uuid
                        this.subTopicUuid = subtopic.uuid
                        break topicLoop
                      }
                    }
                  } else {
                    // subtopic.subtopics === 0
                  }
                }
              } else {
                // topic.subtopics === 0
              }
            }
          }
          if ($('#ic_' + this.topicUuid).hasClass('collapsed')) {
            $('#ic_' + this.topicUuid).trigger('click')
          }
          if ($('#ic_' + this.subTopicUuid).hasClass('collapsed')) {
            $('#ic_' + this.subTopicUuid).trigger('click')
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import '../../../assets/theme/default/sass/mixin';
@import '../../../assets/theme/default/sass/colors';
@import '../../../assets/module/sass/course/toc.scss';

.toc_panel.toc_instructor .list-group-item .toc_row:not(.table-content-header) > .btn_ic.ic-lock {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	flex: 0 0 24px;
	width: 24px;
	height: 24px;
	margin: 0 5px 0 0;
	padding: 0;
	float: none;
	position: static;
	font-size: 35px;
	line-height: 1;
	background: transparent;
	border: 0;
	box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/app/course/components/TOCInstructor.vue